module.exports = __webpack_public_path__ + "static/media/picture_course.2f8a6b65.png";